module.exports = __webpack_public_path__ + "img/profil_lapper_Wahl.ca2f51ad.png";